import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'ease-in', 'EaseIn', [["path",{"d":"M3 20c8 0 18 -16 18 -16","key":"svg-0"}]]);